//Handle taxonomy filtering

import { updateFilterState, filterState } from './postFilters'; // Ensure the import paths are correct
import { getPosts } from './postFilters'; // Ensure the import paths are correct
import $ from 'jquery';

const bindUIEvents = () => {
    document.querySelectorAll('.dropdown-option').forEach(dropdownOption => {
        let checkbox = dropdownOption.querySelector('input[type="checkbox"]');

        if (checkbox.checked) {
            addFilterButton(checkbox);
        }

        checkbox.addEventListener('change', function () {
            updateDropdownLabel(checkbox);

            if (!checkbox.checked) {
                removeFilterButton(checkbox);
            }
            updateFilterState(); // Update state when checkboxes are changed
        });
    });

    document.addEventListener('postfilters.taxonomy.updated', function () {
        document.querySelector('.post-grid-active-filters').innerHTML = '';

        document.querySelectorAll('.dropdown-option').forEach(dropdownOption => {
            let checkbox = dropdownOption.querySelector('input[type="checkbox"]');
            if (checkbox.checked) {
                addFilterButton(checkbox);
            }
            updateDropdownLabel(checkbox);
        });
    });
}

const addFilterButton = (checkbox) => {
    let taxonomy = checkbox.parentNode.dataset.taxonomy;
    let id = checkbox.value;
    let filterLabel = checkbox.parentNode.textContent.trim();

    let buttonElement = document.createElement('button');
    buttonElement.className = "post-grid-active-filter";
    buttonElement.dataset.taxonomy = taxonomy;
    buttonElement.dataset.id = id;

    buttonElement.innerHTML = `<span class="filter-name">${filterLabel}</span>
        <span class="icon"></span>`

    document.querySelector('.post-grid-active-filters').appendChild(buttonElement);

    // Add event listener to remove button on click & uncheck the associated checkbox
    buttonElement.addEventListener('click', function () {
        checkbox.checked = false;
        buttonElement.remove();

        var event = new Event('change');
        checkbox.dispatchEvent(event);

        // Trigger search update when a filter is removed
        updateFilterState();
        const perPage = document.getElementById('posts-load-more')?.getAttribute('data-per-page');
        getPosts(filterState, perPage);
    });
}

const removeFilterButton = (checkbox) => {
    let taxonomy = checkbox.parentNode.dataset.taxonomy;
    let id = checkbox.value;

    let buttonElement = document.querySelector(`.post-grid-active-filter[data-taxonomy="${taxonomy}"][data-id="${id}"]`);
    if (buttonElement) {
        buttonElement.remove();
    }
}

const updateDropdownLabel = (checkbox) => {
    const dropdown = checkbox.closest('.checkbox-dropdown');
    const label = dropdown.querySelector('.dropdown-label');
    const checked = dropdown.querySelectorAll('input[type="checkbox"]:checked');

    if (checked.length <= 0) {
        label.innerHTML = label.dataset.label;
    } else if (checked.length === 1) {
        label.innerHTML = checked[0].parentNode.textContent.trim();
    } else {
        label.innerHTML = `${checked.length} Selected`;
    }
}

const postTaxonomy = () => {
    bindUIEvents();
}

export default postTaxonomy;